/**
 * Centralized configuration for Roof Scanner Plugin
 * Values are injected by Vite at build time from .env file
 */

// Server URL for API calls (injected by Vite define)
// REQUIRED: Must be set in .env as VITE_ROOF_SCANNER_SERVER_URL
export const SERVER_URL = __ROOF_SCANNER_SERVER_URL__;

// Google Maps API Key (injected by Vite define, embedded in plugin build)
// REQUIRED: Must be set in .env as VITE_GOOGLE_MAPS_API_KEY
export const GOOGLE_MAPS_API_KEY = __GOOGLE_MAPS_API_KEY__;

// API endpoints
export const API_ENDPOINTS = {
  CONFIG: '/api/v1/roof-scanner/config',
  SUBMIT_QUOTE: '/api/v1/roof-scanner/submitQuote',
  GET_BUILDING_INFO: '/api/v1/roof-scanner/getBuildingInfo',
  SCAN_ROOF: '/api/v1/roof-scanner/scanRoofNew', // ML-free pipeline (updated from scanRoof)
};
